export const FIND_CHAT_CONVERSATION_SUCCESS = 'FIND_CHAT_CONVERSATION_SUCCESS';

export const findChatConversationSuccess = ({ conversation, count }) => ({
    type: FIND_CHAT_CONVERSATION_SUCCESS,
    payload: { conversation, count },
});
